module.exports = __webpack_public_path__ + "media/src/components/HomePage/HowItWorks/how-it-works-2eebf81e839d90413ffae85e4e79be6d.png";